import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeHighlight from 'rehype-highlight';

/**
 * 본문을 펴는 플러그인 **한 벌** — 렌더러와 고정 케이스가 **같은 것**을 쓴다.
 *
 * ```
 *   remark   글 → 뜻       GFM(표 · 체크목록 · 취소선)
 *   rehype   뜻 → 태그     날 HTML 허용(근거 쪽지 `x-cite`) · 코드 물들이기
 * ```
 *
 * 🚨 **`remarkGfm` 은 remark 자리다** — rehype 자리에 두면 `.use()` 가 파싱 전에 도는 덕에
 *   «우연히» 표가 그려진다. 라이브러리가 조금만 바뀌면 표가 통째로 줄글이 되므로,
 *   우연에 기대지 않는다. 고정 케이스가 이 한 벌을 그대로 편다(`__tests__`).
 * 🚨 **`rehypeRaw` 가 있어야 제 태그가 산다** — 근거 쪽지가 `<x-cite>` 로 들어온다.
 *   빼면 태그가 글자로 드러난다.
 * ⚠️ 홑물결(`~`)은 취소선이 아니다 — 본문의 「~3주」가 줄 그어지지 않게 한다.
 */
export const MARKDOWN_REMARK_PLUGINS: any[] = [[remarkGfm, { singleTilde: false }]];

export const MARKDOWN_REHYPE_PLUGINS: any[] = [rehypeRaw, rehypeHighlight];
